import { MdErrorOutline, MdCheckCircleOutline } from "react-icons/md";
import { FiAlertTriangle } from "react-icons/fi";
import { useAppState } from "../../store"

export const InfoMessage: React.FC = () => {
    const { state } = useAppState()

    const message = state?.message

    if (!message) {
        return <></>
    }

    return (
        <div className='infoMessage'>
            <div className={message.type}>
                <div className='infoMessage__icon'>
                {{
                    'error': <MdErrorOutline color='red' size='20'/>,
                    'alert': <FiAlertTriangle color='orange' size='20' />,
                    'success': <MdCheckCircleOutline color='green' size='20' />
                    }[message.type]}
                </div>
                <div className='infoMessage__icon'>{message.message}</div>
            </div>
        </div>
    )
}